module.exports = __webpack_public_path__ + "static/lightning-c9415a71b2f7a8b2802750a9bd93541a.gif";